import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, of, BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { SilFlowComponent } from '../base-components/sil-flow/sil-flow.component';
import { IndexedDbService, getActiveManifestItem, ModalService, ManifestController, BigFormService } from '@flexus/core';
import { SilWorkflowShellComponent } from '../base-components/sil-workflow-shell/sil-workflow-shell.component';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class DeactivateStateGuard implements OnDestroy, CanDeactivate<SilFlowComponent | SilWorkflowShellComponent> {
	canGo$ = new BehaviorSubject(false);
	canDiscard: boolean;
	manifestItem;
	manifestItemSub: Subscription;
	constructor(
		public indexedDbService: IndexedDbService,
		private controller: ManifestController<any>,
		public store: Store<any>,
		public modalService: ModalService,
		public bf: BigFormService,
		public router: Router
	) {
		this.manifestItemSub = this.controller
			.select(getActiveManifestItem)
			.subscribe(item => (this.manifestItem = item));
	}

	canDeactivate(
		component: SilFlowComponent,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState: RouterStateSnapshot
	): Observable<boolean> | boolean | Promise<boolean> {
		if (this.manifestItem && this.manifestItem.deactivateStateGuard) {
			return this.manifestItem.deactivateStateGuard(this, component, this.router, currentRoute, currentState, nextState).pipe(
				mergeMap((c: any) => c),
			);
		} else {
			return of(true);
		}
	}

	resetCanGoVariable() {
		this.canGo$.next(false);
	}

	ngOnDestroy() {
		if (this.manifestItemSub) this.manifestItemSub.unsubscribe();
	}
}
